import { render } from "./CoinReceiveOverview.vue?vue&type=template&id=0ce01b39&scoped=true"
import script from "./CoinReceiveOverview.vue?vue&type=script&lang=js"
export * from "./CoinReceiveOverview.vue?vue&type=script&lang=js"

import "./CoinReceiveOverview.vue?vue&type=style&index=0&id=0ce01b39&lang=css"
import "./CoinReceiveOverview.vue?vue&type=style&index=1&id=0ce01b39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce01b39"]])

export default __exports__